import { times } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { getData } from "./selectors/data"
import { getMetrics, getSelectedMetric } from "./selectors/metrics"
import { getItems } from "./selectors/items"
import { getDetailsItems, getDetailsData, getFactorsCategories, getTableDownloadData } from "./selectors/details"
import { getStatus } from "./selectors/status"
import { getPositionSet } from "helpers/comparison"
import { Creators } from "./model"
import { getStyleAggregation } from "selectors/styleAggregation"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { VIEW_TYPES } from "helpers/base"
import { getFileName } from "modules/comparison/selectors/"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  required: ["account", "modelId", "positionSets", "startDate", "endDate"],
  data: [...times(5, (n) => {
    return {
      resource: `compareExposurePositionSet${n}`,
      as: null,
      passthrough: n > 0,
      url: ({ modelId, positionSets, startDate, endDate, base, viewType, contentSetId }) => {
        if (!positionSets[n] || positionSets[n].uploading) {
          return null
        }

        const positionSet = getPositionSet(positionSets, n, startDate)

        // If a segment is applied on the positionSet, use that segment on the base
        const baseCopy = { ...base }
        if (positionSet.segment) {
          baseCopy.segment = positionSet.segment
        }

        return {
          id: `${modelId}${JSON.stringify(positionSet)}${startDate}${endDate}${contentSetId}${viewType === VIEW_TYPES.ACTIVE ? JSON.stringify(baseCopy) : ""}`,
          query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!, $contentSetId: String) {
                model (id: $modelId) {
                  simulation (positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
                    exposure (contentSetId: $contentSetId) {
                      date
                      factors { id name category net }
                    }
                  }
                }
              }`,
          variables: {
            modelId,
            positionSet,
            from: startDate,
            to: endDate,
            contentSetId,
            base: viewType === VIEW_TYPES.ACTIVE ? [baseCopy] : undefined,
          },
        }
      },
    }
  }),
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    data: getData(state, props),
    metrics: getMetrics(state, props),
    items: getItems(state, props),
    detailsItems: getDetailsItems(state, props),
    detailsData: getDetailsData(state, props),
    selectedMetric: getSelectedMetric(state, props),
    status: getStatus(state, props),
    ...getStyleAggregation(state, props),
    factorCategories: getFactorsCategories(state, props),
    fileName: getFileName(state, props),
    tableDownloadData: getTableDownloadData(state, props),
  }),
  actions: {
    ...Creators,
    setAggregationFn: PortfolioRootCreators.setAggregationFn,
  },
})
